import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  HEADER: `${cleanedFilename(__filename)}-header`,
  ROW: `${cleanedFilename(__filename)}-row`,
};
